export default __webpack_public_path__ + "static/media/keissifi.5cb9e203.png";